import React from 'react';
import './Loader.scss';

const Loader = ({className}) => {
    return (
        <div className={ 'loader' + (className ? ' ' + className : '') } />
    );
};

export default Loader;